import _ from 'lodash';
import { IdCardsFieldEnum as Fields } from 'Common/FieldEnum';

export const getSelectedStatuses = formValues => {
  const selectedStatuses = _.pickBy(
    formValues,
    (value, key) => _.includes(key, 'Statuses') && value === true
  );

  return Object.keys(selectedStatuses).map(x => {
    return x.match(/\d+/)[0];
  });
};

export const getSpecificStudents = formValues => {
  const inputValue = formValues[Fields.SpecificStudents];

  if (inputValue === undefined || !inputValue) {
    return new Array(0);
  }
  return inputValue.replace(/[\n\r\s]/g, '').split(',');
};



// WEBPACK FOOTER //
// ./src/pages/idcards/helpers/index.js